import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, useTheme } from '@mui/material';
import { FC } from 'react';

import { ConditionField, ConditionFieldProps } from '../condition-field';

type Props = {
  conditionsFields: ConditionFieldProps[],
  onRemove: () => void,
}

export const ConditionForm: FC<Props> = ({
  conditionsFields,
  onRemove
}) => {
  const theme = useTheme();

  return (
    <Box
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'center',
        alignItems: 'flex-end',
        rowGap: theme.spacing(0.5),
      }}
    >
      {conditionsFields.map((conditionFieldProps) => (
        <ConditionField key={conditionFieldProps.prefix} {...conditionFieldProps} />
      ))}
      <IconButton style={{ padding: 0, borderRadius: 0 }} onClick={onRemove} size="large">
        <FontAwesomeIcon icon="times" size="xs" />
      </IconButton>
    </Box>
  );
};
